import { getTrainees } from 'services/axios/trainees'

export const actions = {
  GET_TRAINEES: 'GET_TRAINEES',
  HANDLE_PAGINATION: 'HANDLE_PAGINATION',
}

export const handlePagination = (pagination) => {
  return {
    type: 'HANDLE_PAGINATION',
    payload: pagination,
  }
}

export const getTraineeList = ({ skip, limit, status, trainingStatus }) => {
  return async (dispatch) => {
    const response = await getTrainees({
      skip,
      limit,
      status,
      trainingStatus,
    })

    dispatch({
      type: actions.GET_TRAINEES,
      payload: {
        traineeList: response?.data?.data?.traineeList,
        totalCount: response?.data?.data?.totalCount,
      },
    })
  }
}
